import { createFileRoute } from '@tanstack/react-router'
import { PlaceholderPage } from '@/components/PlaceholderPage'
import { requireNav } from '@/nav/guard'

export const Route = createFileRoute('/_app/tasks')({
  beforeLoad: requireNav('tasks'),
  component: () => <PlaceholderPage id="tasks" />,
})
